/**
 * Enhanced Product Scripts
 * Handles canvas animation, tab switching, and sticky header synchronization
 */

(function() {
  const canvas = document.getElementById('ribbon-canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let width, height;
    let scrollY = 0;

    function resize() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    }

    function drawRibbon(time) {
      ctx.clearRect(0, 0, width, height);
      const colors = ['rgba(212, 175, 55, 0.1)', 'rgba(212, 175, 55, 0.2)', 'rgba(212, 175, 55, 0.15)'];
      const amplitude = 50;
      const frequency = 0.002;
      const speed = 0.0005;
      const scrollFactor = 0.2;

      colors.forEach((color, i) => {
        ctx.beginPath();
        ctx.strokeStyle = color;
        ctx.lineWidth = 40;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        const offset = i * 20;

        for (let x = 0; x <= width; x += 10) {
          const y =
            height * 0.4 +
            offset +
            Math.sin(x * frequency + time * speed + scrollY * scrollFactor * 0.01 + i) *
              amplitude *
              (1 + Math.sin(x * 0.001));

          if (x === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }
        }
        ctx.stroke();
      });
    }

    let time = 0;
    function animate() {
      time++;
      drawRibbon(time);
      requestAnimationFrame(animate);
    }

    window.addEventListener('resize', resize);
    window.addEventListener('scroll', () => {
      scrollY = window.scrollY;
    });

    resize();
    animate();
  }

  // --- Tab Logic ---
  window.switchTab = function(tabId) {
    console.log('Switching to tab:', tabId);
    // Reset Buttons
    document.querySelectorAll('.tab-btn').forEach((btn) => {
      btn.classList.remove('active');
    });
    // Reset Content
    document.querySelectorAll('.tab-content').forEach((content) => {
      content.classList.remove('active');
      setTimeout(() => {
        if (!content.classList.contains('active')) {
          content.style.display = 'none';
        }
      }, 400);
    });

    // Activate Button
    const btn = document.getElementById(`tab-${tabId}-btn`);
    if (btn) btn.classList.add('active');

    // Activate Content
    const activeContent = document.getElementById(`content-${tabId}`);
    if (activeContent) {
      activeContent.style.display = 'block';
      setTimeout(() => {
        activeContent.classList.add('active');
      }, 10);
    }
  };

  // --- Sticky Header Logic ---
  function updateStickyPosition() {
    const tabContainer = document.getElementById('tab-nav-container');
    if (!tabContainer) return;

    const headers = [
      document.getElementById('HeaderWrapper'),
      document.getElementById('SiteHeader'),
      document.querySelector('.site-header'),
      document.querySelector('header'),
    ];

    let topPosition = 0;
    for (const header of headers) {
      if (header && header.offsetHeight > 0) {
        const style = window.getComputedStyle(header);
        if (style.position === 'fixed' || style.position === 'sticky' || header.offsetHeight > 40) {
          topPosition = header.offsetHeight;
          break;
        }
      }
    }

    if (tabContainer.style.top !== `${topPosition}px`) {
      tabContainer.style.top = `${topPosition}px`;
    }
  }

  window.addEventListener('load', updateStickyPosition);
  window.addEventListener('resize', updateStickyPosition);
  window.addEventListener('scroll', updateStickyPosition, { passive: true });
  updateStickyPosition();

  // Ensure the initial active tab is set
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.switchTab('features');
    });
  } else {
    window.switchTab('features');
  }

  console.log('Enhanced Product script loaded!');
})();
